module.exports = __webpack_public_path__ + "media/images/city_img/icon2-c77b4bf0b2025f75b20d4a71e5699caa.png";